import styled from 'styled-components';

const GameStyled = styled.section`
  align-items: center;
  background: ${props => props.theme.game.bg};
  box-shadow: ${props => props.theme.game.boxShadow};
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  justify-content: center;
  opacity: 0;
  padding: calc(60px + 2vmin) calc(20px + 2vmin) calc(20px + 2vmin);
  position: relative;
  transform: scale(0.9);
  transition: transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut},
    opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut};
  transition-delay: ${props => props.theme.transition.durationLong};
  visibility: ${props => (props.viewing ? 'visible' : 'hidden')};

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    flex-direction: row;
    padding: 5vmin 10vmin;
  }

  .game-wrap-enter & {
    display: flex;
    opacity: 0;
    transform: scale(0.9);
  }

  .game-wrap-enter-done & {
    display: flex;
    opacity: 1;
    transform: scale(1);
  }
`;

export default GameStyled;



// WEBPACK FOOTER //
// ./src/components/pages/Game/Game.styled.js